import React, { Component } from 'react';
import { hot } from 'react-hot-loader'
import Header from '../../src/app/components/Header'
import Footer from '../../src/app/components/Footer'
import MainContent from '../../src/app/components/MainContent'
import CompanyIntro from '../../src/app/components/CompanyIntro'
import JoinUs from '../../src/app/components/JoinUs'
import rem from '../../src/app/utils/rem'

import './index.css'

rem(document, window)

@hot(module)
class App extends Component {
  render() {
    return (
      <div>
        <Header/>
        <MainContent />
        <CompanyIntro/>
        <JoinUs/>
        <Footer/>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/app/index.js